import EmergencyContact from './EmergencyContact';

export default EmergencyContact;
